/* eslint-disable linebreak-style */
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
// Include Sweet Alert 2
// @ts-ignore
window.Swal = require('sweetalert2');

// Lazy load
const Lazyload = require('vanilla-lazyload');

const lazyLoadVar = new Lazyload({
  use_native: true,
});

// TinyMCE Core & Plugins
require('tinymce/tinymce');
require('tinymce/models/dom');
require('tinymce/themes/silver');
require('tinymce/icons/default');
require('tinymce/plugins/advlist');
require('tinymce/plugins/anchor');
require('tinymce/plugins/autolink');
require('tinymce/plugins/code');
require('tinymce/plugins/image');
require('tinymce/plugins/link');
require('tinymce/plugins/lists');
require('tinymce/plugins/media');
require('tinymce/plugins/searchreplace');
require('tinymce/plugins/table');
require('tinymce/plugins/wordcount');

require('./bootstrap');
require('@splidejs/splide/dist/js/splide.min.js');

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./components/buttons/favorites');
require('./components/buttons/read-more');
require('./components/buttons/seller-rating');
require('./components/buttons/set-location');
require('./components/buttons/see-location');
require('./components/buttons/ListingPageAdminActions');
require('./components/forms/auth/login');
require('./components/forms/auth/register');
require('./components/forms/ecommerce/paymentMethodManagement');
require('./components/forms/ecommerce/vouchers/CreateVoucher');
require('./components/forms/Register');
require('./components/forms/Partials/EditableField');
require('./components/forms/Partials/EditableDate');

require('./components/slider/homepage-slider');
require('./components/body/block/puppy-breeds');
require('./components/body/card/breed-card');
require('./components/body/card/similar-breed-card');
require('./components/body/card/seller-review-card');
require('./components/body/block/seller-reviews');
require('./components/body/block/breed/breed-at-a-glance-ad');
require('./components/body/block/breed/breed-at-a-glance-main');
require('./components/body/block/breed/BreedPage');
require('./components/body/dashboard/blocks/become-seller-cta');
require('./components/body/slider/breed-carousel');
require('./components/body/slider/breed-simple-carousel');
require('./components/body/slider/litter-card-slider');
require('./components/body/slider/seller-slider');
require('./components/body/slider/puppy-card-slider');
require('./components/body/slider/breed-card-slider');
require('./components/body/card/puppy-card');
require('./components/body/slider/listing-slider');
require('./components/body/block/similar-breeds');
require('./components/body/modal/testimonials-modal');
require('./components/body/modal/SellerReviewFormModal');
require('./components/body/modal/ReportFormModal');
require('./components/body/modal/SecondFactorAuthModal');
require('./components/body/piece/auto-read-more');
require('./components/forms/SellerReviewEdit');
require('./components/forms/TestimonialEdit');
require('./components/body/dashboard/seller-contacts/manage-contacts');

require('./components/forms/SellerContact');
require('./components/forms/BasicContact');
require('./components/forms/AccountDeletionRequest');
require('./components/forms/AccountDeletionRequest/DeleteRequestButton');

// Search
require('./components/search/admin-global-search/AdminGlobalSearch');

require('./components/search/admin-dashboard-tables/AdminDashboardTable');
require('./components/search/admin-dashboard-tables/AdminDashboardTableHits');
require('./components/search/admin-dashboard-tables/AdminDashboardTableHit');
require('./components/search/admin-dashboard-tables/AdminPages');
require('./components/search/admin-dashboard-tables/AdminLitters');
require('./components/search/admin-dashboard-tables/AdminAdsPuppyStudListings');
require('./components/search/admin-dashboard-tables/AdminAdsSuspiciousListings');
require('./components/search/admin-dashboard-tables/AdminAdsRecentlySold');
require('./components/search/admin-dashboard-tables/AdminReportsPuppiesByStateListings');
require('./components/search/admin-dashboard-tables/AdminAccounts');
require('./components/search/admin-dashboard-tables/AdminAccountsSuspiciousFlagged');
require('./components/search/admin-dashboard-tables/AdminSingleSellerProfiles');
require('./components/search/admin-dashboard-tables/AdminSingleProfileContacts');
require('./components/search/admin-dashboard-tables/AdminOrders');
require('./components/search/admin-dashboard-tables/AdminFormSubmissions');
require('./components/search/admin-dashboard-tables/AdminMessages');
require('./components/search/admin-dashboard-tables/AdminBreeds');
require('./components/search/seller-dashboard/seller-profiles/SingleSellerProfiles');
require('./components/search/seller-dashboard/seller-ads/SingleUserAdsDashboard');

// Custom
require('./custom/nav');
require('./custom/register-modal');
require('./custom/tfa-form-resend');
require('./custom/disable-location-modal');
require('./custom/smooth-scroll-with-offset');
require('./custom/gtm-events');
require('./custom/ClassWatcher');

// Breed
require('./components/forms/breed');
require('./components/forms/breed/SortablePopularBreedTable');

// TODO-sam make the following ignored import files type-scripty
// @ts-ignore
// eslint-disable-next-line import/no-unresolved
require('./components/autocomplete');
// @ts-ignore
const {
  pathname,
  // eslint-disable-next-line no-restricted-globals
} = location;
// eslint-disable-next-line no-restricted-globals
if (location.pathname.startsWith('/breeders-search')) {
  require('./components/body/block/breeder-search');
  require('./components/body/block/breeder-links');
} else {
  require('./components/body/block/search');
}
require('livewire-sortable');
require('jquery');
